export default "__VITE_ASSET__BPitCcRT__"